import { AxiosResponse } from "axios";

export const handleForbiddenRead = (res?: AxiosResponse) => {
  if (res?.status === 403) {
    return true;
  }
  return false;
};
